"use strict";

/**
 * Checks if the value is a string.
 * @param {string | String} value
 * @returns {boolean}
 */
function isString(value) {
  return typeof value === "string" || value instanceof String;
}

/**
 * Strips html from a string
 * @param {string | String} value
 * @returns {boolean}
 */
function stripHtml(value) {
  if (!isString(value)) {
    return "";
  }
  const htmlTagRegex = /<\/?([a-zA-Z]\s?)*?([a-zA-Z]+?=\s?".*")*?([\s/]*?)>/gi
  return value.replace(htmlTagRegex, '');
}

module.exports = {
  isString,
  stripHtml
};
